// custom js

$ = jQuery;

jQuery(document).foundation();

var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

var hamburgers = document.querySelectorAll(".hamburger");
if (hamburgers.length > 0) {
  forEach(hamburgers, function(hamburger) {
    hamburger.addEventListener("click", function() {
      this.classList.toggle("is-active");
    }, false);
  });
}
//mute buttons for video on homepage
var vid = document.getElementById("vfigger");
    function enableMute() {
      vid.muted = true;
    }
    function disbleMute() {
      vid.muted = false;
    }

jQuery("button.hamburger").click(function() {
  if(jQuery(this).hasClass('is-active')) {
        jQuery(".mobile-list").removeClass('deactive');
  } else {
      jQuery(".mobile-list").addClass('deactive');
  }
});

//Nav dropdown 
  //mobile menu
  // Removes direct links from first anchor items in menu because these items also serve as the dropdown toggler on mobile
  $('.mobile-list #main-nav li.menu-item-has-children > a').attr('href', '#');

  $('.mobile-list li.menu-item-has-children').click(function(e) {
      $(this).find('ul.menu').toggleClass('is-active');
  });
  
  //desktop menu
  jQuery('.top-nav-menu ul#main-nav li.menu-item-has-children').hover(function(e) {
    jQuery(this).find('ul.menu').toggleClass('is-active');
  });

//.top-nav-menu - header btn
jQuery('.top-nav-menu li.header-btn').attr({'data-fancybox': 'consultation-1','data-src': '#schedule-consultation'});
jQuery('.mobile-list li.header-btn').attr({'data-fancybox': 'consultation-1-m','data-src': '#schedule-consultation'});

//header search bar btn 
$('.mobile-search-btn').on('click', function(event) {
  event.stopPropagation(); // Prevents the event from bubbling up to the document
  var headerSearchBar = $('header.header .searchbar');
  headerSearchBar.toggleClass('active'); // Toggle the active class
});

$(document).on('click', function(event) {
  var target = $(event.target);
  if (!target.closest('.mobile-search-btn').length && !target.closest('header.header .searchbar').length) {
    // If the click is outside the button and the searchbar, remove the active class
    $('header.header .searchbar').removeClass('active');
  }
});

// add data-fancybox attr

jQuery('.fb-link a').attr('data-fancybox', '');

// header BSG Team tab
$('.bsgContact').on('click', function(){
  if ($('.bsgContact').hasClass('bsgc_active')) {
    $('.contactPeople').addClass('hidden');
    $('.bsgContact').removeClass('bsgc_active');
    $('.bsgContact p .dashicons').removeClass('flip');
  } else {
    $('.contactPeople').removeClass('hidden');
    $('.bsgContact').addClass('bsgc_active');
    $('.bsgContact p .dashicons').addClass('flip');
  }
}); 
$(".bsgContact").on("click", function (event) {
  event.stopPropagation();
});

$(document).on("click", function () {
  $('.contactPeople').addClass('hidden');
  $('.bsgContact').removeClass('bsgc_active');
  $('.bsgContact p .dashicons').removeClass('flip');
});

//Counter
jQuery(function() {
  jQuery('.counter').countUp({
    'time': 2000,
    'delay': 10
  });
});

//AOS
jQuery(document).ready(function() {
  jQuery('.fade-up').attr({'data-aos': 'fade-up'});
  jQuery('.fade-down').attr({'data-aos': 'fade-down'});
  jQuery('.fade-right').attr({'data-aos': 'fade-right'});
  jQuery('.fade-left').attr({'data-aos': 'fade-left'});
  // if (typeof ActiveXObject !== "undefined") {
  // } else {
  // jQuery('.fade-up').attr({'data-aos': 'fade-up'});
  // jQuery('.fade-down').attr({'data-aos': 'fade-down'});
  // jQuery('.fade-right').attr({'data-aos': 'fade-right'});
  // jQuery('.fade-left').attr({'data-aos': 'fade-left'});
  // }
});


jQuery(document).ready(function($){

  // If url contains '/esg/additional-resources/#tab-2' string then we toggle tab 2
  if (window.location.href.includes('/esg/additional-resources/#tab-2')) {
    setTimeout(function(){
      $('.tab-menu li').removeClass('active');
      $('.tab-menu a[href=#tab-2]').parents('li').first().addClass('active');
      $('#tab-1').fadeOut(100);
      $('#tab-2').fadeIn(100);
    }, 500);
  }

  // Updates gravity form hidden inputs
  if ($('input[value="{{! UserCompanyName !}}').length > 0) {
    $('input[value="{{! UserCompanyName !}}').val(hiddenFields.user_company);
  }
  if ($('input[value="{{! UserPosition !}}').length > 0) {
    $('input[value="{{! UserPosition !}}').val(hiddenFields.user_position);
  }
  if ($('input[value="{{! userAMname !}}').length > 0) {
    $('input[value="{{! userAMname !}}').val(hiddenFields.userAMname);
  }
  if ($('input[value="{{! userAMemail !}}').length > 0) {
    $('input[value="{{! userAMemail !}}').val(hiddenFields.userAMemail);
  }
  if ($('input[value="{{! userAMid !}}').length > 0) {
    $('input[value="{{! userAMid !}}').val(hiddenFields.userAMid);
  }
  if ($('input[value="{{! userCAname !}}').length > 0) {
    $('input[value="{{! userCAname !}}').val(hiddenFields.userCAname);
  }
  if ($('input[value="{{! userCAemail !}}').length > 0) {
    $('input[value="{{! userCAemail !}}').val(hiddenFields.userCAemail);
  }
  if ($('input[value="{{! userCAid !}}').length > 0) {
    $('input[value="{{! userCAid !}}').val(hiddenFields.userCAid);
  }
  if ($('input[value="{{! userNumber !}}').length > 0) {
    $('input[value="{{! userNumber !}}').val(hiddenFields.userNumber);
  }
  if ($('input[value="{{! inviteeEmail !}}').length > 0) {
    $('input[value="{{! inviteeEmail !}}').val(hiddenFields.inviteeEmail);
  }

  // Tab js
  $("body.bbpress .tab-page, body#egs-main .tab-page").hide();
  $("body.bbpress ul.sub-menu li:first, body#egs-main ul.sub-menu li:first").addClass("active").show();
  $("body.bbpress .tab-page:first, body#egs-main .tab-page:first").show();

  $("ul.sub-menu li").click(function() {
    $("ul.sub-menu li").removeClass("active");
    $(this).addClass("active");
    var activeTab = $(this).find("a").attr("href");
    $(".tab-page").fadeOut(200);
    $(activeTab).delay(250).fadeIn(200);
  });

  /* ----- Table z-index issues fix ----- */  

  /**
   * This code should fix hover issues on td,th elements
   */

  // $("td, th").hover(function(){
  //   $(this).css('z-index', '9999999');
  // });

  //  $("td, th").mouseleave(function(){
  //   $(this).css('z-index', '');
  // });

   // The code below will fix hovering issues for elements with class of description-tooltip

   $(".description-tooltip").hover(function(){
    $(this).css('z-index', '9999999');
  });

   $(".description-tooltip").mouseleave(function(){
    $(this).css('z-index', '');
  });

  /* ----- Removes a site alert when user clicks on .dashicons-no ----- */
  $('.site-alert .dashicons-no').click(function(){
    $(this).parents('.site-alert').first().remove();
  });

  /**
   * Allows us to created nested tab menus
   * 
   * 1. Simply create a <ul> element with class of "nestable-tab-menu"
   * 2. Add <li> tags with <a> elements inside them
   * 3. The <a> elements must have an href attribute that 
   * references the id of a div element with class of tab page
   * (E.g. <a href='#tab-page-1'>Tab Page 1</a> must reference <div id='tab-page-1' class='tab-page'></div>)
   * 
   * Note: "nestable-tab-menu" and "nestable-tab-page" must share the same immediate parent
   * 
   * We can nest tab menus and tab pages within another tab page 
   * however keep in mind it is important for "nestable-tab-menu" and "nestable-tab-page" 
   * to share same parent for it to work properly
   */
    $("ul.nestable-tab-menu").each( function (){

      let tab_menu = $(this);

      let parent_el = $(this).parent();

      let child_tab_pages = $(parent_el).find(' > .nestable-tab-page');

      $(child_tab_pages).hide();

      if ($(tab_menu).find("li.active").length < 1) { // No active li element, so we set first li element to be active
        $(tab_menu).find('li:first').addClass("active").show();
      }

      $(child_tab_pages).first().show();

      $(tab_menu).find('li').click(function(){
        $(tab_menu).find('li').removeClass("active");
        $(this).addClass('active');
        $(parent_el).find(' > .nestable-tab-page').fadeOut();

        $($(this).find("a").attr("href")).delay(250).fadeIn(200);
      });

    } );

  $('.login-message').delay(400).fadeIn(3000);

  /* -------------------- Company Portfolio JS -------------------- */

    if ( $('#company-portfolio').length > 0 ){

      /**
       * Fades out #maturity-score-description-tooltip on portfolio page when user clicks
       * on .nestable-tab-menu <a> element with href of #action-items 
       */
      $("ul.nestable-tab-menu li a").click(function(){
        if ($(this).attr('href') == '#action-items') {
          $('#maturity-score-description-tooltip').fadeOut(100);
          $('#action-items-description-tooltip').fadeIn(100);
        }else{
          $('#maturity-score-description-tooltip').fadeIn(100);
          $('#action-items-description-tooltip').fadeOut(100);
        }
      });

    }

  /* -------------------- Survey And Reports: Analysis Page JS -------------------- */

  if ( $('#analysis-page').length > 0 ){

    /**
     * Fades out #maturity-score-description-tooltip on portfolio page when user clicks
     * on .nestable-tab-menu <a> element with href of #action-items 
     */
    $(".tab-menu li a").click(function(){
      if ($(this).attr('href') == '#tab-4') {
        $('#maturity-score-description-tooltip').fadeOut(100);
      }else{
        $('#maturity-score-description-tooltip').fadeIn(100);
      }
    });

  }

  // Shows Maturity Label Filter only when Categorized View tab is active 
  $('.tab-menu li a').click(function(){

    if ($(this).text() == 'BuildRI Maturity') {
      $('#maturity-level-filter').delay(200).fadeIn(100);
    }else{
      $('#maturity-level-filter').delay(200).fadeOut(100);
    }

  });

  // Maturity Level Filter Dropdown function
  $('#maturity-level-filter .select-box').click(function(){

    let custom_select = $(this).parents('.custom-select');

    if ( $(custom_select).hasClass('active') ) {
      $(custom_select).removeClass('active');
      $(custom_select).find('.select-options').slideUp(200);
    }else{
      $(custom_select).addClass('active');
      $(custom_select).find('.select-options').slideDown(200);
    }

  });

  // When Maturity Level Filter option is selected update filter
  $('#maturity-level-filter .select-options span').click(function(){
    
    let parent_container = $(this).parents('#maturity-level-filter');

    // Updates Select Box Text
    let text = $(this).text();
    $(parent_container).find('.custom-select .selected').text(text);

    let selected_index_value = $(this).index();

    if (selected_index_value > 0) {

      /**
       * Find <td> where the first instance of a half incomplete bar occurs
       * If the <td> index matches the selected_index_value then we'll keep that <td> 
       * or else we hide <td>
       */

      $('#analysis-categories tbody tr').each(function(){

        if ( $(this).hasClass('unfilterable') ) { return; } // Does not filter Table Rows with class of unfilterable

        if ( $(this).find('.bar.half-incomplete').length !=0 && $(this).find('.bar.half-incomplete').eq(0).parents('td').index() != selected_index_value ) {
          $(this).fadeOut();
        }
        else if( $(this).find('.bar.complete').last().parents('td').index() == 5 && selected_index_value != 5 ){
          $(this).fadeOut();
        }
        else{
           $(this).fadeIn();
        }
      });

    }else{
       $('#analysis-categories tbody tr').fadeIn();
    }

  });

  // Maturity Level Category Analysis Current State and Future State Hover Tooltip
  $('table tbody .bar-cell .bar.half-complete').hover(function(){
    
    $('.current-state').removeClass('active');
    
    let table_row = this;

    let table_data_bars = $(table_row).find('.complete, .half-complete');

    let table_data_bars_width = 0;

    for(let i = 0; i < table_data_bars.length; i++){
      table_data_bars_width += $(table_data_bars[i]).width();
    }

    if ($(table_row).find('.current-state').length == 0) {
      $(table_row).append("<div class='current-state active'><span>Current State</span></div>");
      $(table_row).find('.current-state').css('width', table_data_bars_width);
    }else{
      $(table_row).find('.current-state').addClass('active');
    }

  });

  $('.flag-container').hover(function(){
    $('.future-state').removeClass('active');
    let table_row = this;
    $(table_row).find('.future-state').addClass('active');
  });

  /* -------------------- Survey And Reports: Results Page JS -------------------- */

  // Code to run on dom load
  $(document).ready(function(){

    $(".target-state-Q .selected_choice").each(function() {
      $(this).prevAll('.choice').andSelf().addClass('active');
    });

  })

  // Removes subcategory html if there are no questions under subcategories 
  if ($('.survey-results .subcategory')) {
    $('.subcategory').each(function(){

      /**
       * If subcategory field next field element is also subcategory, 
       * then current subcategory field has no questions
       * or if subcategory field next field element is empty
       * then remove current subcategory field
       */

      if ( $(this).next().hasClass('subcategory') || $(this).next().length == 0 ) {
        $(this).remove();
      }

    });
  }

  $('.download-dropdown .dropdown, .account-dropdown .dropdown').click(function(){

    let dropdown_menu = $(this).parent('.download-dropdown, .account-dropdown').find('ul.dl-options, ul#login-menu');

    if ($(dropdown_menu).hasClass('active')) {
      $(dropdown_menu).removeClass('active');
      $(dropdown_menu).slideUp(200);
    }else{
      $(dropdown_menu).addClass('active');
      $(dropdown_menu).slideDown(200);
    }

  });

  $(".download-dropdown .dropdown, .account-dropdown .dropdown").on("click", function (event) {
    event.stopPropagation();
  });
  
  $(document).on("click", function () {
    $('ul.dl-options, ul#login-menu').removeClass('active');
    $('ul.dl-options').slideUp(200);
  });

  /* -------------------- Survey And Reports: Portfolio View JS -------------------- */

  // Toggles dropdowns
  $('.dropdown-toggler').click(function(){

    let dropdown_parent = $(this).parent('.dropdown');

    if ($(dropdown_parent).hasClass('active')) {
      $(dropdown_parent).removeClass('active');
    }else{
      $(dropdown_parent).addClass('active');
    }

  });

  /**
   * Makes a tables column sortable simply just add class of sortable to table header
   * 
   * Note: By default, when comparing the values in table cells it assumes the values to be strings
   * 
   * To specify integer value, simply add attribute data-sorting-type='int' to the table header
   * This will convert the string values to integer values and compare their values as integers rather then strings
   * 
   * To specify a different sort value then the one in the table cell, simply just add data-sort-value
   * attribute to td element and set the data value we want to compare
   * 
   */
  $('table th.sortable').click(function(){

    let sorting_type = $(this).attr('data-sorting-type');

    if ( sorting_type && sorting_type.length == 0) { sorting_type = 'string' }

    let index = $(this).index() + 1; // Index of header (starts from 1)

    let table = $(this).parents('table').first();

    let table_rows = $(table).find('tbody tr');

    let first_tr = $(table).find('tbody tr').first();

    let tr_count = $(table).find('tbody tr').length;

    let sort_direction = 'ASC';

    // Current col is already sorted in ascending order, so instead we sort in descending
    if( $(this).hasClass('sorted-asc') ){
      sort_direction = 'DESC';      
    }

    // Removes sorted-asc class from all <th> elements in table
    $('table th.sortable').removeClass('sorted-asc');

    // If sort direction is ascending, then we'll add 'sorted-asc' class to <th>
    // so if user clicks on column next time we'll know its already sorted in ascending order
    // and we'll sort in descending order
    if (sort_direction == 'ASC') {
      $(this).addClass('sorted-asc');
    }

    // Bubble sort on table rows
    for( let i = 0; i < tr_count - 1; i++ ){
      for( let x = 0; x < tr_count - i - 1; x++){

        let tr_one = $(table_rows).get(x);

        let tr_two = $(table_rows).get(x+1);

        let td_one = $(tr_one).find('td:nth-of-type('+index+')');

        let td_two = $(tr_two).find('td:nth-of-type('+index+')');

        let td_sort_value_1 = $(td_one).attr('data-sort-value') ? $(td_one).attr('data-sort-value') : $(td_one).text();
        let td_sort_value_2 = $(td_two).attr('data-sort-value') ? $(td_two).attr('data-sort-value') : $(td_two).text();

        // Converts values to float number for comparison
        if (sorting_type == 'number') {
          td_sort_value_1 = parseFloat( td_sort_value_1.replace(/[^0-9.]/g, '') );
          td_sort_value_2 = parseFloat( td_sort_value_2.replace(/[^0-9.]/g, '') );
        }

        if (sort_direction == 'DESC') {

          if ( td_sort_value_1 < td_sort_value_2 ) {

            // Perform swap
            $(tr_two).insertBefore(tr_one);

            // Update table_rows var
            table_rows = $(table).find('tbody tr');
          }
          
        }else{

          if ( td_sort_value_1 > td_sort_value_2 ) {

            // Perform swap
            $(tr_one).insertAfter(tr_two);

            // Update table_rows var
            table_rows = $(table).find('tbody tr');

          }

        }

      }
    }

  });

  // Note: forced click to ASC sort for Limited Partner role view: Portfolio Monitoring > BuildRI Scores
  // $('table th#overall-th').click();
 
  /* Note: Cloned Functionality - only for KPI Tracking results views for AMA only */
  // AMA KPI Results View
  $( document ).ready(function() {
    let table_kpi = $('table#reported-kpi-table th.sortable');

    let sorting_type = $(table_kpi).attr('data-sorting-type');

    if ( sorting_type && sorting_type.length == 0) { sorting_type = 'string' }

    let index = $(table_kpi).index() + 1; // Index of header (starts from 1)

    let table = $(table_kpi).parents('table').first();

    let table_rows = $(table).find('tbody tr');

    let first_tr = $(table).find('tbody tr').first();

    let tr_count = $(table).find('tbody tr').length;

    let sort_direction = 'DESC';

    // Current col is already sorted in ascending order, so instead we sort in descending
    if( $(table_kpi).hasClass('sorted-asc') ){
      sort_direction = 'ASC';      
    }

    // Removes sorted-asc class from all <th> elements in table
    $('table th.sortable').removeClass('sorted-asc');

    // If sort direction is ascending, then we'll add 'sorted-asc' class to <th>
    // so if user clicks on column next time we'll know its already sorted in ascending order
    // and we'll sort in descending order
    if (sort_direction == 'ASC') {
      $(table_kpi).addClass('sorted-asc');
    }

    // Bubble sort on table rows
    for( let i = 0; i < tr_count - 1; i++ ){
      for( let x = 0; x < tr_count - i - 1; x++){

        let tr_one = $(table_rows).get(x);

        let tr_two = $(table_rows).get(x+1);

        let td_one = $(tr_one).find('td:nth-of-type('+index+')');

        let td_two = $(tr_two).find('td:nth-of-type('+index+')');

        let td_sort_value_1 = $(td_one).attr('data-sort-value') ? $(td_one).attr('data-sort-value') : $(td_one).text();
        let td_sort_value_2 = $(td_two).attr('data-sort-value') ? $(td_two).attr('data-sort-value') : $(td_two).text();

        // Converts values to float number for comparison
        if (sorting_type == 'number') {
          td_sort_value_1 = parseFloat( td_sort_value_1.replace(/[^0-9.]/g, '') );
          td_sort_value_2 = parseFloat( td_sort_value_2.replace(/[^0-9.]/g, '') );
        }

        if (sort_direction == 'DESC') {

          if ( td_sort_value_1 < td_sort_value_2 ) {

            // Perform swap
            $(tr_two).insertBefore(tr_one);

            // Update table_rows var
            table_rows = $(table).find('tbody tr');
          }
          
        }else{

          if ( td_sort_value_1 > td_sort_value_2 ) {

            // Perform swap
            $(tr_one).insertAfter(tr_two);

            // Update table_rows var
            table_rows = $(table).find('tbody tr');

          }

        }

      }
    }

  });

  /**
   * Helper function created to figure out whether number is integer
   */
  function isInt(value) {
    return !isNaN(value) && 
           parseInt(Number(value)) == value && 
           !isNaN(parseInt(value, 10));
  }

  // Displays table subcategories
  $('.category-table-header ').click( function(){

    let table = $(this).parents('table').first();

    let el = $(this);

    $('.subcategory-table-header').fadeOut(100);
    $('.subcategory-table-data').fadeOut(100);

    if ($(el).hasClass('active')) {

      $('.category-table-header').removeClass('active');

       while($(el).next().hasClass('subcategory-table-header')){
        el = $(el).next();

        $(el).css('display', 'none');

        let th_index = $(el).index();

        $(table).find('tbody tr').each(function(){
          $(this).find('td').eq(th_index).css('display', 'none');
        });
        
      }

    }else{

      $('.category-table-header').removeClass('active');

      $(el).addClass('active')

      while($(el).next().hasClass('subcategory-table-header')){
        $(el).next().css('display', 'table-cell');
        el = $(el).next();

        let th_index = $(el).index();

        $(table).find('tbody tr').each(function(){
          $(this).find('td').eq(th_index).css('display', 'table-cell');
        });
        
      }

    }

  });

  // Shows portfolio-average section 
  $('.summary .summary-title .maximize').click(function(){ 
    $(this).fadeOut(100, function(){
      $('.summary .summary-title .minimize').fadeIn(100);
    });
    $('.summary .portfolio-average').css('display', 'flex');
  });

  // Hides portfolio-average section 
  $('.summary .summary-title .minimize').click(function(){ 
    $(this).fadeOut(100, function(){
      $('.summary .summary-title .maximize').fadeIn(100);
    });
    $('.summary .portfolio-average').slideUp(100);
  });

  // On Company Portfolio Performance Page, 
  // when user clicks a checkbox question row, 
  // we'll show all of the checkbox answers and their selection
  $('.checkbox-question-row').click(function(){
    let el = $(this);

    $('.checkbox-answer-row').css('display', 'none');

    if ( $(this).hasClass('active') ) {
      $(this).removeClass('active');
      return;
    }
    
    $(this).addClass('active');

    while($(el).next().hasClass('checkbox-answer-row')){

      el = $(el).next();

      $(el).slideDown(100);

    }
  });

  /**
   * Table with rows of category and subcategory, clicking on category row will toggle all of the following 
   * rows with the class of portfolio-subcategory
   */
  $('#portfolio-view tbody .portfolio-category td:first-of-type').click(function(){

    let el = $(this).parents('.portfolio-category').first();

    if ( !$(el).hasClass('active') ) {

      $(el).addClass('active');

      // Loops through all following elements with class of tr-subcategory and displays them
      while($(el).next().hasClass('portfolio-subcategory')){
        el = $(el).next();
        $(el).slideDown(100);
      }

    }else{

      $(el).removeClass('active');

      // Loops through all following elements with class of tr-subcategory and hides them
      while($(el).next().hasClass('portfolio-subcategory')){
        el = $(el).next();
        $(el).slideUp(100);
      }

    }

  });

  /**
   * Allows for tables, to have dropdown table rows
   */
  $('td.has-dropdown-table-row').click(function(){

    let table = $(this).parents('table').first();

    let tr = $(this).parent('tr');

    if (!$(table).hasClass('allow-multiple-tr-to-be-expanded')) {

      $('tr.dropdown-table-row').css('display', 'none');

      $('td.has-dropdown-table-row').parent('tr').not(tr).removeClass('active');
    
    }

    if ( $(tr).hasClass('active') ) {
      $(tr).removeClass('active');
    }else{
      $(tr).addClass('active');
    }

    if ($(tr).hasClass('active')) {
      while($(tr).next().hasClass('dropdown-table-row')){
        tr = $(tr).next();
        $(tr).slideDown(100);
      }
    }else{
      while($(tr).next().hasClass('dropdown-table-row')){
        tr = $(tr).next();
        $(tr).slideUp(100);
      }
    }

  });

  $('table.allow-multiple-tr-to-be-expanded td.has-dropdown-table-row').each(function(){

    let tr = $(this).parent('tr');

    if ($(tr).hasClass('active')) {
      while($(tr).next().hasClass('dropdown-table-row')){
        tr = $(tr).next();
        $(tr).slideDown(100);
      }
    }

  });

  $('#kpi-processes-and-initiatives .card-header-options .maximize').click(function(){
    console.log("maximize");
    $(this).hide();
    let card = $(this).parents('.card').first();
    $(card).find('.card-body').slideDown(100);
    $(card).find('.card-header-options .minimize').fadeIn(100);
  });

  $('#kpi-processes-and-initiatives .card-header-options .minimize').click(function(){
    console.log("minimize");
    $(this).hide();
    let card = $(this).parents('.card').first();
    $(card).find('.card-body').slideUp(100);
    $(card).find('.card-header-options .maximize').fadeIn(100);
  });



  // Applies class of col-hovering to all td elements in the same column as current td being hovered over
  $('table.highlight-col-on-hover td').hover(function(){
    let table = $(this).parents('table').first();
    let index = $(this).index() + 1;

    $(table).find('td, th').removeClass('col-hovering');

    $(table).find('td:nth-of-type('+ index +'), th:nth-of-type('+ index +')').addClass('col-hovering');

  });

  // Category & Year Filter Dropdown Function
   
  // Category & Year Filter Dropdown Function
  $('.category-filter .selected-value, .filter-list .selected-value').click(function(event){
    let parent = $(this).parents('.category-filter, .filter-list').first();
      event.stopPropagation();
      //$(".showup").slideToggle("fast");

      $(parent).addClass('active');
      $(parent).find('.dropdown-options').slideToggle("fast");
  });
  $(".dropdown-options").on("click", function (event) {
      event.stopPropagation();
  });

  $(document).on("click", function () {
    $('.category-filter, .filter-list').removeClass('active');
    $('.dropdown-options').hide();
  });

  // $('.category-filter .selected-value, .year-filter .selected-value').click(function(){

  //   let parent = $(this).parents('.category-filter, .year-filter').first();

  //   if ( !$(parent).hasClass('active') ) {

  //     $(parent).addClass('active');
  //     $(parent).find('.dropdown-options').slideDown(100);
  //   }else{
  //     $(parent).removeClass('active');
  //     $(parent).find('.dropdown-options').slideUp(100);
  //   }
    
  // });


  // Year Filter Dropdown Code -- START
  $('.year-filter .dropdown-options li').click(function(){

      let selected_li = $('.year-filter .dropdown-options li[class="selected-option"]');
      let new_selected_value = $('.year-filter .selected-value span');
      let new_selected_year =  $(this).attr('data-year'); 
     
      $(selected_li).removeClass('selected-option');
      $(this).addClass('selected-option');
      $(new_selected_value).text(new_selected_year);
  });

  $( document ).ready(function() {

    let url_query = window.location.search;
    let url_query_instance = new URLSearchParams(url_query);
    let survey_year_exists_in_url = url_query_instance.get('survey_year');
    let kpi_year_exists_in_url = url_query_instance.get('kpi_year');

    let year_dropdown = $('.year-filter .selected-value');
    let parent = $(year_dropdown).parents('.year-filter').first();
    // let default_year_html = $('.year-filter .selected-value span').html();
    let default_year_value = $('.year-filter .selected-value span');
    // let current_year = (new Date).getFullYear()+ 1;
   
    // if survey_year exists in the url
    if(survey_year_exists_in_url && !kpi_year_exists_in_url){
        $(parent).addClass('active');
        $(parent).find('[data-year='+survey_year_exists_in_url+']').addClass('selected-option');
        $(default_year_value).text(survey_year_exists_in_url);

    }else if(!survey_year_exists_in_url && kpi_year_exists_in_url){
        $(parent).addClass('active');
        $(parent).find('[data-year='+kpi_year_exists_in_url+']').addClass('selected-option');
        $(default_year_value).text(kpi_year_exists_in_url);
    }

  });

  // Year Filter Dropdown Code -- END

  // Category Filter Dropdown select function
  $('.category-filter .dropdown-options li').click(function(){

    let parent = $(this).parents('.category-filter').first();

    $(parent).find('.dropdown-options li').removeClass('selected-option');

    $(this).addClass('selected-option');

    let selected_category = $(this).text();

    $(parent).find('.selected-value span').text( selected_category );

    let table = $($(parent).attr('data-table-reference'));

    if (selected_category == 'All') {
      $(table).find('tbody tr').slideDown(100);
    }else{

      $(table).find('tbody tr').each(function(){
        $(this).not('.unfilterable').slideUp(100);
      });

      // If list item has attribute data-category-class
      // Then we'll use the class specified in data-category-class, otherwise we'll just use the text in li
      if ($(this).attr('data-category-class')) {

        let cat_class = $(this).attr('data-category-class');

        $(table).find('tbody .'+cat_class+'').slideDown(100);

      }else{

        /**
         * $.escapeSelector allows for us to select classes with unicode characters
         * For example .category-Process/Procedure is a valid class in css
         * However, jquery does not allow us to select the class without using $.escapeSelector
         */

        $(table).find('tbody .category-'+ $.escapeSelector(selected_category)+'').slideDown(100);
        
      }

    }

  });

  //Value Creation filters
  $('#insights-page .multi-filters .dropdown-options li').click(function(){

    let selected_category = $(this).text();
    let parent = $(this).parents('.filter-list');
    let cat_class = $(this).attr('data-category-class');
    let table = $($(parent).attr('data-table-reference'));

    $(parent).find('.selected-value span').text( selected_category );
    
    if ( $(parent).hasClass('benefit-filter') ) {
      if ( $(this).hasClass('all') ) {
        $(this).addClass('selected-option');
        $(parent).find('.dropdown-options li:not(.all)').removeClass('selected-option');
        $('.filter-selected span.benefit-select').remove();
      } else {
        $(parent).find('.dropdown-options li.all').removeClass('selected-option');
        $(this).toggleClass('selected-option');

        if ( $(this).hasClass('selected-option') ) {
          let benefit_classes = $('<span class="benefit-select '+cat_class+'-select"></span>').text('.'+cat_class+'');
          $('.filter-selected').append(benefit_classes);
        } else if ( $(this).not('.selected-option') ) {
          $('.filter-selected span').remove('.'+cat_class+'-select');
        }
      }
    } else {
      $(parent).find('.dropdown-options li').removeClass('selected-option');
      $(this).addClass('selected-option');
      if ( $(this).hasClass('selected-option') ) {
        let industry_classes = $('<span class="industry-select '+cat_class+'-select"></span>').text('.'+cat_class+'');
        $('.filter-selected').append(industry_classes);
        $('.filter-selected span.industry-select').not('.'+cat_class+'-select').remove();
      }
    }
    
    if (selected_category == 'All') {
      //$(table).find('tbody tr').slideDown(100);
      $('.undefined-select').remove();
      if( $('.filter-selected:empty').length ) {
        $(table).find('tbody tr').slideDown(100);
      } else {
        let selected_class = $('.filter-selected').text();
        $(table).find('tbody '+selected_class+'').slideDown(100);
      }
    } else{

      $(table).find('tbody tr').each(function(){
        $(this).slideUp(100);
      });

      // If list item has attribute data-category-class
      // Then we'll use the class specified in data-category-class, otherwise we'll just use the text in li
      if ($(this).attr('data-category-class')) {
        let selected_class = $('.filter-selected').text();
        $(table).find('tbody '+selected_class+'').slideDown(100);

      }else{

        /**
         * $.escapeSelector allows for us to select classes with unicode characters
         * For example .category-Process/Procedure is a valid class in css
         * However, jquery does not allow us to select the class without using $.escapeSelector
         */

        $(table).find('tbody .category-'+ $.escapeSelector(selected_category)+'').slideDown(100);
        
      }

    }

  });
  
  //reset multi filters
  $('.multi-filters .reset-filter').on('click', function(){
    $('.filter-selected span').remove();
    $(this).parent('.filter').find('.dropdown-options li').removeClass('selected-option');
    $(this).parent('.filter').find('.dropdown-options li:first-child').addClass('selected-option');
    $(this).parent('.filter').find('.selected-value span').text('All');
		$(this).parent('.filter').parent('.tab-page').find('table').find('tr').show();
  });

  //ESG Ratings Search filters
  $('#esg-ratings .multi-filters .dropdown-options li, #esg-ratings-search .multi-filters .dropdown-options li,  #esg-ratings-results .multi-filters .dropdown-options li').click(function(){
    // console.log('here');
    let selected_category = $(this).text();
    let parent = $(this).parents('.filter-list');
    let cat_class = $(this).attr('data-category-class');

    $(parent).find('.selected-value span').text( selected_category );
    
    if ( $(parent).hasClass('investment-filter') ) {
        $(this).toggleClass('selected-option');

        if ( $(this).hasClass('selected-option') ) {
          // console.log($(this).attr('data-category-class'));
          let investment_classes = $('<span class="investment-select '+cat_class+'-select"></span>').text('.'+cat_class+'');
          $('.filter-selected-investment').append(investment_classes);

        } else if ( $(this).not('.selected-option') ) {
          $('.filter-selected-investment span').remove('.'+cat_class+'-select');
        }

        // update the hidden input for the Category filter
        $(function() {
          var selected_options = [];
          $('.filter-selected-investment > .investment-select').each(function(){
            selected_options.push($(this).text().replace('.',''));
          });
          $('#filter-selected-investment').val(selected_options);
        });

    } else if( $(parent).hasClass('location-filter') ) {
        $(this).toggleClass('selected-option');

        if ( $(this).hasClass('selected-option') ) {
          let location_classes = $('<span class="location-select '+cat_class+'-select"></span>').text('.'+cat_class+'');
          $('.filter-selected-location').append(location_classes);
        } else if ( $(this).not('.selected-option') ) {
          $('.filter-selected-location span').remove('.'+cat_class+'-select');
        }

        // update the hidden input for the Locations filter
        $(function() {
          var selected_options = [];
          $('.filter-selected-location > .location-select').each(function(){
            selected_options.push($(this).text().replace('.',''));
          });
          $('#filter-selected-location').val(selected_options);
        });
    }
  });



  

  /* -------------------- General Settings Page: Survey Settings -------------------- */

  if ($('#survey-settings-page').length > 0) {

    let survey_id = $('.survey-fields').attr('data-survey-id');

    let current_field_id; // Will keep track of id of current field for which we're adding/deleting tags

    /**
     * 
     * Comments for variable field_choice_id:
     * 
     * Keeping track of id of current field choice for which we're adding/deleting tags
     * 
     * If field is type radio, then the id will simply be the index of the choice
     * Ex: Checkbox Question 22 will have choices 0, 1, 2, 3, etc...
     * 
     * If field is type checkbox, then the id will simply be the id of the checkbox
     * Ex: Checkbox Question 22 will have checkboxes 22.1, 22.2, 22.3, etc...
     * 
     * If this is set to null, then user wants to add a tag not for the choices of a field but rather the field itself
     * 
     */
    let field_choice_id;

    let survey_tags = {};

    // Shows add a tag modal
    $('.btn-add-a-tag').click(function(){

      update_current_field_id(this);

      $('#add-a-tag-modal').css('display', 'flex');

      update_field_choice_id(this);

    });

    // User hit button to add tag 
    $('button[data-action=add_tag]').click(function(){

      // Setting up variables
      let tag_name_input =  $('.create-a-tag select[name=tag_name]');

      let tag_name = $(tag_name_input).val().trim();

      if ( !(tag_name.length > 0) ) { return; }

      let tag_value_input = $('.create-a-tag input[name=tag_value]');

      let tag_value = $(tag_value_input).val().trim();

      let field = $('.field[data-field-id='+current_field_id+']');

      let tag_container;

       // If field_choice_id is set, then that means we're adding tag to a choice
      if (field_choice_id != null) {
        tag_container = $(field).find('.tag-container[data-choice-id="'+field_choice_id+'"]');
      }else{
        tag_container = $(field).find('.tag-container:not([data-choice-id])');
      }

      // Updating backend with newly added tag
      wp_add_survey_tag(survey_id, current_field_id, field_choice_id, tag_name, tag_value);

      // Adding tag to frontend
      let tag_el;

      if (tag_value.length > 0) { // Tag value isset
        tag_el = '<span class="tag">'+tag_name+' : '+tag_value+'</span>';
      }else{
        tag_el = '<span class="tag">'+tag_name+'</span>';
      }

      $(tag_container).find('.btn-add-a-tag').before(tag_el);

      // Clearing tag inputs
      $(tag_value_input).val('');

      // Adding Tag to Recently added tags
      let recently_added_tags = $('#add-a-tag-modal .recently-used-tags .tag');

      let recently_added_tag_already_exists = false;

      $(recently_added_tags).each(function(){

        let tag_text_html = tag_name;

        if ( tag_value.length > 0 ) {
          tag_text_html += " : "+ tag_value;
        }

        if ($(this).text().trim() == tag_text_html ) {
          recently_added_tag_already_exists = true;
          return;
        }
      });

      // If recently_added_tags exceeds 4 then remove first (Oldest) tag
      if (recently_added_tags.length > 4 && !recently_added_tag_already_exists) {
        $('#add-a-tag-modal .recently-used-tags .tag')[0].remove(); // Remove first (Oldest) tag
      }

      if ( !recently_added_tag_already_exists ) {
         $(recently_added_tags).last().after($(tag_el).clone()); // Adds new tag
      }

      // Finally Close Modal
      $('#add-a-tag-modal').fadeOut(200); 

    });

    /**
     * Adds a tag from a recent used tag
     */
    $('#add-a-tag-modal .recently-used-tags, #add-a-tag-modal .default_tags').on('click', '.tag', function(){
      
      // Setting Up Variables

      let tag_split = $(this).text().split(' : ');
      
      let tag_name = tag_split[0];
      let tag_value = tag_split[1] ? tag_split[1] : null; 

      let field = $('.field[data-field-id='+current_field_id+']');

      let tag_container;

       // If field_choice_id is set, then that means we're adding tag to a choice
      if (field_choice_id != null) {
        tag_container = $(field).find('.tag-container[data-choice-id="'+field_choice_id+'"]');
      }else{
        tag_container = $(field).find('.tag-container:not([data-choice-id])');
      }

      // Updating backend with newly added tag
      wp_add_survey_tag(survey_id, current_field_id, field_choice_id, tag_name, tag_value);

      // Adding tag to frontend

      let tag_html_text = tag_name;

      if ( tag_value ) {
        tag_html_text += " : "+ tag_value;    
      }

      let tag_el = '<span class="tag">'+ tag_html_text +'</span>';
      $(tag_container).find('.btn-add-a-tag').before(tag_el);

      // Finally Close Modal
      $('#add-a-tag-modal').fadeOut(200); 

    });

    /**
     * Will update the current field id
     * 
     * @param tag - element inside tag container
     * 
     */
    function update_current_field_id( tag ){

      // Update current field id
      current_field_id = $(tag).parents('.field').first().attr('data-field-id');

    }

    /**
     * Will update the field_choice_id
     * 
     * If user clicked on a tag within a tag container that has attribute data-choice-id, then its a choice tag
     * Otherwise user wants to add a tag to the field itself, so we set field_choice_id to null
     * 
     * @param tag - element inside tag container
     * 
     */
    function update_field_choice_id( tag ){
      let tag_container = $(tag).parents('.tag-container');

      let choice_id = $(tag_container).attr('data-choice-id');

      field_choice_id = choice_id ? choice_id : null;
    }

    // When user clicks on tag we will remove the tag
    $('.field').on('click', '.tag', function(){

      update_current_field_id(this);

      update_field_choice_id(this);

      let tag_split = $(this).text().trim().split(' : ');

      let tag_name = tag_split[0];

      let tag_value = tag_split[1];

      wp_delete_survey_tag(survey_id, current_field_id, field_choice_id, tag_name, tag_value);

      $(this).remove();

    })

  }

  /**
   * Will add survey tag in backend
   */
  function wp_delete_survey_tag(survey_id, field_id, choice_id = null, tag_name, tag_value = null){

    let data = {
      'action': 'delete_tag',
      'survey_id': survey_id,
      'field_id': field_id,
      'choice_id': choice_id,
      'tag_name': tag_name,
      'tag_value': tag_value,
    };

    $.ajax({
      type: "POST",
      url: hiddenFields.ajax_url,
      data: data,
      success: function(msg){
        console.log('success');
        console.log(msg);

      },
      error: function(msg){
        console.log('error');
        console.log(msg);
      },
    });

  }

  /**
   * Will add survey tag in backend
   */
  function wp_add_survey_tag(survey_id, field_id, choice_id = null, tag_name, tag_value = null){

    let data = {
      'action': 'add_tag',
      'survey_id': survey_id,
      'field_id': field_id,
      'choice_id': choice_id,
      'tag_name': tag_name,
      'tag_value': tag_value,
    };

    $.ajax({
      type: "POST",
      url: hiddenFields.ajax_url,
      data: data,
      success: function(msg){
        console.log(msg);
      },
      error: function(msg){
        console.log(msg);
      },
    });

  }


  /* -------------------- Global Modal JS Functions -------------------- */

  /**
   * Closes modal if user clicked
   * 1. Outside Modal
   * 2. On dashicons-no (x dashicon)
   * 3. An element (typically button), with attribute 'data-modal-action' set to 'close'
   */
  $('.modal-container').click(function(e){
    // user clicked on exit icon or user clicked outside modal
    if( $(e.target).parents('.modal').length == 0 || $(e.target).hasClass('dashicons-no') || $(e.target).attr('data-modal-action') == 'close' ){
      $(this).fadeOut(100);
    }
  });

  var deleting_a_notification = false;

  $('.delete-notification').hover(function(){
      
      if (deleting_a_notification) { $(this).css('cursor', 'wait'); }

  });

  /* Notification Card Delete Functionality */
  $('.delete-notification').on('click', function(){

    // Do Not delete more notifications until this is set back to false
    if (deleting_a_notification == true) { return; }

    deleting_a_notification = true;

    let notification_card = $(this).parents('.notification-card').first();

    let notification_card_index = $(notification_card).attr('data-notification-index');

    $(notification_card).addClass('deleting');

    let data = {
      'action': 'delete_user_notification',
      'notification_card_index': notification_card_index,
    };

    $.ajax({
      type: "POST",
      url: hiddenFields.ajax_url,
      data: data,
      success: function(msg){
        if( msg == 'success' ){
          deleting_a_notification = false;
          $(notification_card).remove();
        }
      },
      error: function(msg){
        console.log('error');
        console.log(msg);
      },
    });

  });

  $('a.notification-card').click(function(e){

    // Cancel link click if window clicked on delete-notification class
    if ($(e.target).hasClass('delete-notification')) {
       e.preventDefault();
    }

  });

  /* --------------- Network Page JS --------------- */

  let network_form = $('.network-form');

  if ($(network_form).length > 0) {

    if (hiddenFields.user_roles.includes("limited_asset_manager_admin") || hiddenFields.user_roles.includes("limited_company_admin")) { // User is limited_asset_manager_admin
      let gform_footer = $(network_form).find('.gform_footer');

      $(gform_footer).after(`<div style="padding:5em;">
          <div class="limited_feature_notification_box">
              <h3>This information is only visible to BuildRI subscribers</h3>
              <a href="/esg/inquiry/">
                  <button type="button" class="dark-green-btn">Contact Us</button>
              </a>
          </div>
      </div>`);

      $(gform_footer).remove();

    }

  }


});


jQuery('.cats .special').on('click', function(){
  jQuery(this).css('display', 'none');
  jQuery(this).parent('.cats').find('.cat.hide').removeClass('hide');
});
jQuery('#newPolicy').on('click', function(){
  jQuery('#modal-AddNew').removeClass('hide');
});
jQuery('#policies .actionMenu .rename').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  window.location.href = "/esg/company-policies/?postID_rename="+ ID;
});
jQuery('.lp-policies .actionMenu .rename').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  window.location.href = "/esg/internal-documents-lp/?postID_rename="+ ID;
});

jQuery('.actionMenu .editApproval').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#modal-approvalStatus').removeClass('hide');
  jQuery('#modal-approvalStatus .popup #hidden').attr('value',ID);
});
jQuery('.actionMenu .delete').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#modal-deletePost').removeClass('hide');
  jQuery('#modal-deletePost .popup #hidden').attr('value',ID);
  jQuery('#modal-deletePost .popup #delete').attr('value','yes');
});
jQuery('.actionMenu .archive').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#modal-archivePost').removeClass('hide');
  console.log(ID);
  jQuery('#modal-archivePost .popup #hidden').attr('value',ID);
  jQuery('#modal-archivePost .popup #archive').attr('value','yes');
});
jQuery('#policies .actionMenu .editLabels').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  // jQuery('#modal-changeLabels').removeClass('hide');
  // jQuery('#modal-changeLabels .popup #hidden').attr('value',ID);
  window.location.href = "/esg/company-policies/?postID_labels="+ ID;
});
jQuery('.lp-policies .actionMenu .editLabels').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  // jQuery('#modal-changeLabels').removeClass('hide');
  // jQuery('#modal-changeLabels .popup #hidden').attr('value',ID);
  window.location.href = "/esg/internal-documents-lp/?postID_labels="+ ID;
});
jQuery('.lp-policies .actionMenu .newUpload').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#modal-changeUpload').removeClass('hide');
  if (Cookies.get('postID') != ID || Cookies.get('postID') == undefined) {
    Cookies.set('postID', ID);
    window.location.href = "/esg/internal-documents-lp/?cookie=true";
  }
});
jQuery('.surveyPoliciesEntries .actionMenu .editLabels').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  var fieldID = jQuery(jQuery(this)[0].parentElement)[0].id;
  jQuery('#modal-changeLabels').addClass('hide');
  jQuery('#modal-changeLabelsBottom').removeClass('hide');
  jQuery('#modal-changeLabelsBottom .popup #hidden').attr('value',ID);
  jQuery('#modal-changeLabelsBottom .popup #fieldID').attr('value',fieldID);
});

jQuery('.contentLibrary .actionMenu .edit').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#cl_modal-Edit').removeClass('hide');
  if (Cookies.get('postID2') != ID || Cookies.get('postID2') == undefined) {
    Cookies.set('postID2', ID);
    window.location.href = "/esg/content-library/?cookie=true";
  }
});
jQuery('.modal #closeModal').on('click', function(){
  jQuery('.modal').addClass('hide');

  Cookies.remove('postID');
  Cookies.remove('postID2');
  Cookies.remove('newLink');

});
jQuery('.modal .cancel').on('click', function(){
  jQuery('.modal').addClass('hide');
});

//KPI Tracking Modal Box
jQuery('.modal .kpi-cancel').on('click', function(){
  jQuery('.modal').addClass('hide');
  jQuery('.modal-container').css('display', 'none');
});
// jQuery(document).keyup(function(e) {
//      if (e.key === "Escape") { // escape key maps to keycode `27`
//         jQuery('.modal').addClass('hide');
//         Cookies.remove('postID');
//         Cookies.remove('postID2');
//         Cookies.remove('newLink');
//         jQuery('.actionMenu').addClass('hide');
//         jQuery('#checkboxes').addClass('hide');

//     }
// });
jQuery('.contentLibrary .actionMenu .rename').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#cl_modal-rename .popup #hidden').attr('value',ID);
  jQuery('#cl_modal-rename').removeClass('hide');
  window.location.href = "/esg/content-library/?postID3="+ID;
});
jQuery('.contentLibrary .actionMenu .edit').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#cl_modal-Edit').removeClass('hide');
  if (Cookies.get('postID2') != ID || Cookies.get('postID2') == undefined) {
    Cookies.set('postID2', ID);
    window.location.href = "/esg/content-library/?cookie=true";
  }
});
jQuery('.contentLibrary .actionMenu .linkRename').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#cl_modal-Edit .popup #hidden').attr('value',ID);
  jQuery('#cl_modal-Edit').removeClass('hide');
  window.location.href = "/esg/content-library/?linkRename="+ID;
});
jQuery('.contentLibrary .actionMenu .newLink').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#cl_modal-Edit').removeClass('hide');
  if (Cookies.get('newLink') != ID || Cookies.get('newLink') == undefined) {
    Cookies.set('newLink', ID);
    window.location.href = "/esg/content-library/?cookie=true";
  }
});
jQuery('.modal .cancel').on('click', function(){
  jQuery('.modal').addClass('hide');
});

jQuery('.actionMenu .restore').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  jQuery('#modal-restorePost').removeClass('hide');
  jQuery('#modal-restorePost .popup #hidden').attr('value',ID);
  jQuery('#modal-restorePost .popup #restore').attr('value','yes');
});
jQuery('.modal .popup .cats .cat input:checkbox').on('click', function(){
  var id =jQuery(this)[0].id;
  jQuery('.modal .popup .cats .cat label[for="'+ id +'"]').toggleClass("selected");
})
if (top.location.pathname === '/esg/company-policies/' || top.location.pathname === '/esg/company-policies/#tab-2') {
  jQuery(document).ready(function() {
    var titles = jQuery('.entry .title');
    for (var i = 0; i < titles.length; i++) {
      var elem = titles[i];
      var text= elem.innerText;
      var len = text.length;
      if (len > 25){
        jQuery(elem).text(text.substr(0,24)+'... ');
      }
    }
  });
  jQuery('#policies .actionMenu .newUpload').on('click', function(){
    var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
    jQuery('#modal-changeUpload').removeClass('hide');
    if (Cookies.get('postID') != ID || Cookies.get('postID') == undefined) {
      Cookies.set('postID', ID);
      window.location.href = "/esg/company-policies/?cookie=true";
    }
  });
  jQuery('#modal-changeUpload #closeModal').on('click', function(){
    Cookies.remove('postID');
  });

  // POLICIES FILTER JS
  
  // // Show Drop Down
  // $('.p_category-filter .selected-value').click(function(){

  //   let parent = $(this).parents('.p_category-filter').first();

  //   if ( !$(parent).hasClass('active') ) {
  //     $(parent).addClass('active');
  //     $(parent).find('.dropdown-options').slideDown(100);
  //   }else{
  //     $(parent).removeClass('active');
  //     $(parent).find('.dropdown-options').slideUp(100);
  //   }
    
  // });

  // Category Filter Dropdown select function
  $('#policies .p_category-filter .dropdown-options li').click(function(){

    let parent = $(this).parents('.p_category-filter').first();
    let selected_category = $(this).text();

    // Entry ID to unhide
    let id = 'cat-' + $(this)[0].id;

    // Hides all the entries only if nothing is hidden
    if ( $('.entries .entry.hide').length == 0 
      && selected_category !== 'All') {
      $('.entry').addClass('hide');
    }

    if (selected_category == 'All') {
      $(parent).find('.dropdown-options li').removeClass('selected-option');
      $('.entry').removeClass('hide');
      $('#All').addClass('selected-option'); 
      $(parent).find('.selected-value span').text( 'All' );

    }else{

      // 
      if ($(this).hasClass('selected-option') ){
        $('.entries .' + id).addClass('hide');
        $(this).removeClass('selected-option');

        if ($('.entries .entry.hide').length == $('.entry').length ) {
          $('.entry').removeClass('hide');
          $(parent).find('.dropdown-options li').removeClass('selected-option');
          $('#All').addClass('selected-option'); 
          $(parent).find('.selected-value span').text( 'All' );
        }
        else{
          let tempName = $('.selected-option')[0].outerText;
          $(parent).find('.selected-value span').text( tempName );
        }
      }
      else{
        $('.entries .' + id).removeClass('hide');
        $(this).addClass('selected-option');
        $('#All').removeClass('selected-option');
        $(parent).find('.selected-value span').text( selected_category );
      }
    }
  });

}
if (top.location.pathname === '/esg/company-policies/' 
    || top.location.pathname === '/esg/company-policies/#tab-2'
    || top.location.pathname === '/esg/content-library/' ) {
 
  // Close modal when clicking outside of it
  jQuery(document).click(function(event) {
    if (!jQuery(event.target).closest(".modal .popup").length 
        && !jQuery(event.target).closest(".actionMenu").length 
        && !jQuery(event.target).closest("#newPolicy").length
        && !jQuery(event.target).closest("#newContent").length) {
      jQuery(".modal").addClass("hide");
    }
    if (!jQuery(event.target).closest(".actionMenu").length 
        && !jQuery(event.target).closest(".action i").length) {
      jQuery('.actionMenu').addClass("hide");

    }
    // if (!jQuery(event.target).closest(".dropdown-options").length 
    //     && !jQuery(event.target).closest(".dropdown-options li").length) {
    //     jQuery('.dropdown-options').css('display', 'none');
    // }
  });
}

if(top.location.pathname === '/esg/additional-resources/'){

  $(".actionContainer").on('click', function(e){
  if($($(this)[0].children[1])[0].classList.contains('hide')){
    $('.actionMenu').addClass('hide');
    $($(this)[0].children[1]).toggleClass('hide');

  }else{
    $($(this)[0].children[1]).toggleClass('hide');
  }
  });

  $('.actionMenu .delete-invite').on('click', function(){
    
    let tr = $(this).parents('tr').first();
    let invite_id = tr.attr('data-invite-id');

    $('#modal-deletePost input[name=delete_invite]').val(invite_id);

    $('#modal-deletePost').removeClass('hide'); // Shows Delete Post Modal

  });

  // Modal functionality
  $('.actionMenu .rename').on('click', function(){

    let tr = $(this).parents('tr').first();

    let invite_id = tr.attr('data-invite-id');

    let curr_name = $(tr).find('td').first().text();

    $('#rename-form-modal-container').css('display', 'flex');

    $('#rename-form-modal-container input[name=invite_id]').val(invite_id);

    $('#rename-form-modal-container input[name=assessment_invite_new_name]').val(curr_name);

  });

  // Hides Rename Form Modal
  $('#rename-form-modal-container').click(function(e){

    if ( $(e.target).hasClass('rename-form-modal-hide-btn') || $(e.target).hasClass('cancel-btn') ) {
      $('#rename-form-modal-container').css('display', 'none');
    }

    if ( $(e.target).attr('id') == 'rename-form-modal-container' ) {
      $('#rename-form-modal-container').css('display', 'none');
    }
    
  });



}
// Content Library JS
jQuery('#newContent').on('click', function(){
  jQuery('#modal-newContent').removeClass('hide');
});

// Archive Tab JS
jQuery('.yearTitle').on('click',function(){
  let sibling = jQuery(jQuery(this)[0].nextElementSibling);
  jQuery(sibling[0]).toggleClass('hide');
  
  let imgControl = jQuery(jQuery(jQuery(jQuery(this)[0].lastChild))[0]);
  
  let getUrl = window.location;
  let baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
  let img1 = baseUrl + '/wp-content/themes/esg-theme/assets/images/showMoreArrow.svg';
  let img2 = baseUrl + '/wp-content/themes/esg-theme/assets/images/showLessArrow.svg';

  if(jQuery(imgControl).attr('src') == img1){
    jQuery(imgControl).attr('src', img2); 
  }
  else {
    jQuery(imgControl).attr('src', img1);
  }        
});

function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

// Click actionMenu dots and show the menu
jQuery('.action .fa-ellipsis-h').on('click', function(){
  var ID = jQuery(jQuery(this)[0].parentElement.parentElement)[0].id;
  var menu = jQuery("#" + ID + " .actionMenu");
  if (jQuery(menu)[0].classList.contains('hide')) {
    jQuery('.actionMenu').addClass('hide');
    menu.removeClass('hide');
  }else{
    menu.addClass('hide');
  }

});


// Policies Page Filter
var expanded = false;

function showCheckboxes() {
  var checkboxes = document.getElementById("checkboxes");
  if (!expanded) {
    // checkboxes.style.display = "block";
    jQuery('#checkboxes').removeClass('hide');
    expanded = true;
  } else {
    // checkboxes.style.display = "none";
    jQuery('#checkboxes').addClass('hide');
    expanded = false;
  }
}

// Get URL PARAMS
function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

// Check off any cat from filters with they come from URL PARAM
var query = window.location.search.substring(1);
var qs = parse_query_string(query);
const keys = Object.values(qs);
for (var i = 0; i < keys.length; i++) {
  var current = keys[i];
  var search = "#cat-" + current;
  jQuery("#cat-"+current).attr("checked", true);
}

function capitalize(str){
  const lower = str.toLowerCase();
  return str.charAt(0).toUpperCase() + lower.slice(1);
}


// Analytics front end page js
if(top.location.pathname === '/esg/analytics-frontend/'){
  $=jQuery;
  
  // Click on the right area to then show the users on the left
  $('.right .userRoles').on('click', function(e){
    var searchID = $(this)[0].id;
    if ($('.totalUsers_Section .left .hide').length == 4 ) {
      $('.totalUsers_Section .left .' + searchID).toggleClass('hide');
      $('.totalUsers_Section .right .btn').toggleClass('hide');
    }
    else{
      if ($('.totalUsers_Section .left .' + searchID).hasClass('hide')) {
        $('.totalUsers_Section .left .userSection').addClass('hide');
        $('.totalUsers_Section .left .' + searchID).removeClass('hide');
      }
      else{
        $('.totalUsers_Section .right .btn').addClass('hide');
        $('.totalUsers_Section .left .' + searchID).addClass('hide');
      }
    }
  });

  // Click the button under right section to close out modals
  $('.totalUsers_Section .right .btn').on('click', function(e){
      $('.totalUsers_Section .right .btn').toggleClass('hide');
      $('.totalUsers_Section .left .userSection').addClass('hide');
  });

  // Open section different tabs
  $('.pageviews .title').on('click', function(e){
    $('.pageviews .userSection').toggleClass('hide');
    $('.pageviews .title img').toggleClass('flipArrow');
  });

  $('.btnClicked .title').on('click', function(e){
    $('.btnClicked .userSection').toggleClass('hide');
    $('.btnClicked .title img').toggleClass('flipArrow');
  });

  $('.downloaded .title').on('click', function(e){
    $('.downloaded .userSection').toggleClass('hide');
    $('.downloaded .title img').toggleClass('flipArrow');
  });

 $('.inquiry .title').on('click', function(e){
    $('.inquiry .userSection').toggleClass('hide');
    $('.inquiry .title img').toggleClass('flipArrow');
  });

  $('.network .title').on('click', function(e){
    $('.network .userSection').toggleClass('hide');
    $('.network .title img').toggleClass('flipArrow');
  });

  $('.policiesInfo .title').on('click', function(e){
    $('.policiesInfo .userSection').toggleClass('hide');
    $('.policiesInfo .title img').toggleClass('flipArrow');
  });

  $('.assessmentSection .title').on('click', function(e){
    $('.completedAssessments').toggleClass('hide');
    $('.assessmentSection .title img').toggleClass('flipArrow');
  });
}



// EDCI JS
if (window.location.href.includes('/esg/edci')) {
  $('#send_data').on('click', function(e){
    $.ajax({
      url: window.location.origin + '/esg/api-edci-response/?call=true',
      type:'GET',
      success:function(data){
        $('main').append(data);
        $('#send_data').hide();
      }
    });
  });
}
// Company Fundamental
if (window.location.href.includes('/esg/company-fundamentals')) {
  const optionMap = {
        default: [],
        Consumer_Goods: ['Apparel, Accessories & Footwear', 'Appliance Manufacturing', 'Building Products & Furnishings','E-Commerce', 'Household & Personal Products', 'Multiline and Specialty', 'Retailers & Distributors', 'Toys & Sporting Goods'], 
        Extractives_and_Mineral_Processing:['Coal Operations', 'Construction Materials', 'Iron & Steel Producers', 'Metals & Mining', 'Oil & Gas - Exploration & Production', 'Oil & Gas - Midstream', 'Oil & Gas - Refining & Marketing', 'Oil & Gas - Services'], 
        Financials:['Asset Management & Custody Activities', 'Commercial Banks', 'Consumer Finance', 'Insurance', 'Investment Banking & Brokerage', 'Mortgage Finance', 'Security & Commodity Exchanges'], 
        Food_and_Beverage:['Agricultural Products', 'Alcoholic Beverages', 'Food Retailers & Distributors', 'Meat', 'Poultry & Dairy', 'Non-Alcoholic Beverages', 'Processed Foods', 'Restaurants', 'Tobacco'], 
        Health_Care:['Biotechnology & Pharmaceuticals', 'Drug Retailers', 'Health Care Delivery', 'Health Care Distributors', 'Managed Care', 'Medical Equipment & Supplies'], 
        Infrastructure:['Electric Utilities & Power Generators', 'Engineering & Construction Services', 'Gas Utilities & Distributors', 'Home Builders', 'Real Estate', 'Real Estate Services', 'Waste Management', 'Water Utilities & Services'], 
        Renewable_Resources_and_Alternative_Energy:['Biofuels', 'Forestry Management', 'Fuel Cells & Industrial Batteries', 'Pulp & Paper Products', 'Solar Technology & Project Developers', 'Wind Technology & Project Developers'], 
        Resource_Transformation:['Aerospace & Defense', 'Chemicals', 'Containers & Packaging', 'Electrical & Electronic Equipment', 'Industrial Machinery & Goods'], 
        Services:['Advertising & Marketing', 'Casinos & Gaming', 'Education', 'Hotels & Lodging', 'Leisure Facilities', 'Media & Entertainment', 'Professional & Commercial Services'], 
        Technology_and_Communications:['Electronic Manufacturing Services & Original Design Manufacturing', 'Hardware', 'Internet Media & Services', 'Semiconductors', 'Software & IT Services', 'Telecommunication Services'], 
        Transportation:['Air Freight & Logistics', 'Airlines', 'Auto Parts', 'Automobiles', 'Car Rental & Leasing', 'Cruise Lines', 'Marine Transportation', 'Rail Transportation', 'Road Transportation']
  }

  function addOption(selectElement, text) {
    let option = document.createElement('option');
    option.value = text;
    option.textContent = text;
    selectElement.append(option);
  }


  $('.sector_code').on('change', function (e){
      
    var sector_ID = e.currentTarget.id.split('_')[0];
    var sector_name = e.currentTarget.value;
    var sector_key = sector_name.replace(/&/g,"and").replace(/ /g, "_");
    var options = optionMap[sector_key];

    var indus_field = $('#'+sector_ID+'_industry')[0];
    console.log(sector_name);
    
    
    if (sector_name == "") {
      indus_field.innerHTML = '<option value> Please select an option above </option>';
    }else{
      indus_field.innerHTML = '';
      for (var i = 0; i < options.length; i++) {
        addOption(indus_field, options[i]);
      }
    }

  });

  $(document).keyup(function(e) {
    if (e.key === "Escape") {
      $('#modal-popUp').addClass('hide');
    }
  });
  $('#submit-btn').on('click', function(e){
    e.preventDefault();
    $('#modal-popUp').toggleClass('hide');
  });
  
  $('#modal-popUp #no').on('click', function(e){
    $('#modal-popUp').addClass('hide');
  });
  
  $('#modal-popUp #yes').on('click', function(e){
    $('#hiddenSubmitFlag').val('true');
    $('form').unbind('submit').submit();
  });
}

// Check if the current URL contains /#consultation-1
if (window.location.href.indexOf('/#consultation-1') > -1) {

  let consultation_btn = $('[data-fancybox="consultation-1"]').first();

  if (consultation_btn.length > 0) {

    $(consultation_btn).click();

  }
   
}


/*
  Mass Upload JS
*/
  if (window.location.href.includes('/esg/mass-user-upload')) {
    $('.selector h2').on('click', function(e){
      if(!$(this)[0].classList.contains('curr')){

        // Handles the menu
        $('.selector h2').removeClass('curr');
        $(this).addClass('curr');

        //Handles the form switch
        var targetFormClass = $(this)[0].classList[0];
        $('form').addClass('hide');
        $("#" + targetFormClass).removeClass('hide');

      }
    });
  }
/*
  End Mass Upload JS
*/
/* ------------------------------ Gravity Forms Additional JS ------------------------------ */

// Code to run on dom load
$(document).ready(function(){

  $(".target-state-Q .gchoice input:checked").each(function() {
    $(this).parent('.gchoice').prevAll('.gchoice').andSelf().addClass('active');
  });

})

// When user clicks on gchoice input on target-state-Q run the code
$(".target-state-Q .gchoice input").click(function(){

  // Adds class active to current gchoice and all gchoice before the selected one
  $(this).parent('.gchoice').prevAll('.gchoice').andSelf().addClass('active');

  // Removes class active to all gchoice after the selected one
  $(this).parent('.gchoice').nextAll('.gchoice').removeClass('active');

});

// profiles nav js
if (window.location.href.includes('/esg/profiles/')) {
  if ($(window).width() <= 768) {
    // Removes direct links from first anchor items in menu because these items also serve as the dropdown toggler on mobile
    $('#menu-profiles-menu li.menu-item-has-children > a').attr('href', '#');

    $('li.menu-item-has-children').click(function(e) {
        $(this).find('ul.sub-menu').toggleClass('is-active');
    });
    
  }else{
    jQuery('.top-nav-menu ul#menu-profiles-menu li.menu-item-has-children').hover(function(e) {
      jQuery(this).find('ul.sub-menu').toggleClass('is-active');
    });
  }

  $(document).keyup(function(e) {
    if (e.key === "Escape") {
      $('.gfForm-workedwfirm').addClass('hide');
    }
  });
  // $('#gform_wrapper_74').attr('data-closeModal').click(function(){
  //   $('.gfForm-workedwfirm').addClass('hide');  
  // });
}

$(".hide-form").on('click', function(e){
  $('.profile-question').addClass('hide');
});

// Create a tooltip element
$('body').append('<div class="profile-tooltip"></div>');

$('.profile-tooltip-btn').on('mouseenter click', function(event) {
  var tooltipText = $(this).data('tooltip');
  var tooltip = $('.profile-tooltip');

  tooltip.text(tooltipText);
  var offset = $(this).offset();
  var height = $(this).outerHeight();
  var width = $(this).outerWidth();

  tooltip.css({
    top: offset.top + height + 10 + 'px', // Position below the button with a small margin
    left: offset.left + (width / 2) - (tooltip.outerWidth() / 2) + 'px' // Center the tooltip
  });

  tooltip.show();
  event.stopPropagation(); // Prevents the event from bubbling up to the document
});

$('.profile-tooltip-btn').on('mouseleave', function() {
  $('.profile-tooltip').hide();
});

$(document).on('click', function() {
  $('.profile-tooltip').hide();
});

// Optional: Hide tooltip if the user scrolls
$(window).on('scroll', function() {
  $('.profile-tooltip').hide();
});

// RATING SEARCH JS
if (window.location.href.includes('/esg/ratings-search')) {
  jQuery('.top-nav-menu ul li.menu-item-has-children').hover(function(e) {
    jQuery(this).find('ul.sub-menu').toggleClass('is-active');
  });

  // $("#modal-request-profile p").on('click', function(e){
  //   $('.modal').removeClass('hide');
  // });

  $("#hide-modal").on('click', function(e){
    $('.modal').addClass('hide');
  });
  
  function comparator(a, b) { 
      if (a.dataset.firm_name < b.dataset.firm_name) 
          return -1; 
      if (a.dataset.firm_name > b.dataset.firm_name) 
          return 1; 
      return 0; 
  } 
  function reverse_comparator(a, b) { 
      if (a.dataset.firm_name < b.dataset.firm_name) 
          return 1; 
      if (a.dataset.firm_name > b.dataset.firm_name) 
          return -1; 
      return 0; 
  } 
  
  $("#btnClick").on('click', function(e){
    // $(".results .dropdown").removeClass('hide');
    if ($('#btnClick').hasClass('bsgc_active')) {
      $('.dropdown').addClass('hide');
      $('#btnClick').removeClass('bsgc_active');
    } else {
      $('.dropdown').removeClass('hide');
      $('#btnClick').addClass('bsgc_active');
    }
    $(".dropdown p").on('click', function(d){
      var sortName = $(this)[0].innerHTML;
      $(".results .container b")[0].innerHTML = sortName;
      $(".dropdown p").removeClass('curr');
      $(this).addClass('curr');
      
      var sortID = $(this)[0].id;
      var wrapper = $('.results');
      switch(sortID){
        case 'scoredown':
            wrapper.find('.result').sort(function(a, b) {
                return +b.dataset.firm_score - +a.dataset.firm_score;
            }).appendTo(wrapper);
            break;
        case 'scoreup': 
          wrapper.find('.result').sort(function(a, b) {
                return +a.dataset.firm_score - +b.dataset.firm_score;
            }).appendTo(wrapper);
            break;
        case 'compdown':

          wrapper.find('.result').sort(comparator).appendTo(wrapper);
            break;
        case 'compup': 
          wrapper.find('.result').sort(reverse_comparator).appendTo(wrapper);
            break;
      }
    });
  });
  $("#btnClick").on("click", function (event) {
    event.stopPropagation();
  });
  $(document).on("click", function () {
    $('.dropdown').addClass('hide');
    $('#btnClick').removeClass('bsgc_active');
  });
  $("#clearFilters").on('click', function(e){
    $(".filter ul li").removeClass('curr');
    var results = $('.results .result');
    results.each(function(firms){
      $(this).removeClass('hide');
    });
    $(this).addClass('hide');
  });
  $('.filter ul li').on('click', function(e){
    var wantedCats = [];
    var cats = getCats();
    var geos = getGeos();
    

    if ($(this)[0].classList.contains('curr')) {
      $(this).removeClass('curr');
    }else{
      $(this).addClass('curr');
      $('#clearFilters').removeClass('hide');
    }

    if ($(".filter ul .curr").length == 0) {
      $(".filter ul li").removeClass('curr');
      $("#clearFilters").addClass('hide');

      var results = $('.results .result');
      results.each(function(point){
        $(this).removeClass('hide');
      });
      return;
    }
    else if ($(".filter ul .curr").length == 1) {
      wantedCats.push($(".filter ul .curr")[0].innerHTML);
    }
    else if ($(".filter ul .curr").length > 1) {
      $(".filter ul .curr").each(function(){
        if (wantedCats.includes($(this)[0].innerHTML)) {
          var index = wantedCats.indexOf($(this)[0].innerHTML);
          wantedCats.splice(index, 1);
          $(this).removeClass('curr');
        }
        else{
          wantedCats.push($(this)[0].innerHTML);
        }
      });
    }
    var filterCat = getFilterCats(wantedCats);


    if (filterCat.includes('cat') && filterCat.includes('geo')) {
      showMultiFilterContent(wantedCats);
    }else if(filterCat.includes('cat')){
      showFilteredContent('firm_cat', wantedCats);
    }else if(filterCat.includes('geo')){
      showFilteredContent('firm_geo', wantedCats);
    }

    function getCats(){
      var cats = [];
      var cat_li_elem = $("#filter-cat li");
      var cat_li_array = [...cat_li_elem];
      cat_li_array.forEach(function(li) {
        cats.push(li.innerText);
      });
      return cats;
    }
    function getGeos(){
      var geos = [];
      var geo_li_elem = $("#filter-geo li");
      var geo_li_array = [...geo_li_elem];
      geo_li_array.forEach(function(li) {
        geos.push(li.innerText);
      });
      return geos;

    }
    function getFilterCats(wantedCats){
      var filterCat = [];
      wantedCats.forEach(function(label){
        if (cats.includes(label) && !filterCat.includes('cat')) {
          filterCat.push('cat');
        }else if(geos.includes(label)&& !filterCat.includes('geo')){
          filterCat.push('geo');
        }
      });
      return filterCat;
    }
    function showFilteredContent(elem , wantedCats){
      var results = $('.results .result');
      results.each(function(firm){
        $(this).removeClass('hide');
        if (elem == 'firm_cat') {
          if (wantedCats.includes(this.dataset.firm_cat)){
          }else{
            $(this).toggleClass('hide');
          }
        }else{
          if (wantedCats.includes(this.dataset.firm_geo)){
          }else{
            $(this).toggleClass('hide');
          }
        }
      });
    }
    function showMultiFilterContent(wantedCats){
      var results = $('.results .result');
      results.each(function(firm){
        $(this).removeClass('hide');
        if (wantedCats.includes(this.dataset.firm_cat) && wantedCats.includes(this.dataset.firm_geo)){
        }else{
          $(this).toggleClass('hide');
        }
      });
    }
  });
}
// new homepage js
if ( $('#post-2174').length > 0 ) {
  $('.tabs p').on('click', function(e){
    $('.tabs p').removeClass('curr');
    $(this).addClass('curr');
    var idToUnhide = "#" + $(this)[0].classList[0];
    $('.feat_cats').addClass('hide');
    $(idToUnhide).removeClass('hide');
  })

  $('.r_newProfile').on('click', function(e){
    $("#r_newProfile").css('display', 'flex');
  })
}
if (window.location.href.includes('/esg/firm-cat')) {
  jQuery('.top-nav-menu ul li.menu-item-has-children').hover(function(e) {
    jQuery(this).find('ul.sub-menu').toggleClass('is-active');
  });
  function comparator(a, b) { 
      if (a.dataset.firm_name < b.dataset.firm_name) 
          return -1; 
      if (a.dataset.firm_name > b.dataset.firm_name) 
          return 1; 
      return 0; 
  } 
  function reverse_comparator(a, b) { 
      if (a.dataset.firm_name < b.dataset.firm_name) 
          return 1; 
      if (a.dataset.firm_name > b.dataset.firm_name) 
          return -1; 
      return 0; 
  } 
  
  $("#btnClick").on('click', function(e){
    // $(".results .dropdown").removeClass('hide');
    if ($('#btnClick').hasClass('bsgc_active')) {
      $('.dropdown').addClass('hide');
      $('#btnClick').removeClass('bsgc_active');
    } else {
      $('.dropdown').removeClass('hide');
      $('#btnClick').addClass('bsgc_active');
    }
    $(".dropdown p").on('click', function(d){
      var sortName = $(this)[0].innerHTML;
      $("#firm-archive .sort .container b")[0].innerHTML = sortName;
      $(".dropdown p").removeClass('curr');
      $(this).addClass('curr');
      
      var sortID = $(this)[0].id;
      var wrapper = $('#firm-archive #firms');
      switch(sortID){
        case 'scoredown':
            wrapper.find('.firm').sort(function(a, b) {
                return +b.dataset.firm_score - +a.dataset.firm_score;
            }).appendTo(wrapper);
            break;
        case 'scoreup': 
          wrapper.find('.firm').sort(function(a, b) {
                return +a.dataset.firm_score - +b.dataset.firm_score;
            }).appendTo(wrapper);
            break;
        case 'compdown':

          wrapper.find('.firm').sort(comparator).appendTo(wrapper);
            break;
        case 'compup': 
          wrapper.find('.firm').sort(reverse_comparator).appendTo(wrapper);
            break;
      }
    });
  });
  $("#btnClick").on("click", function (event) {
    event.stopPropagation();
  });
  $(document).on("click", function () {
    $('.dropdown').addClass('hide');
    $('#btnClick').removeClass('bsgc_active');
  });
}
if (window.location.href.includes('/esg/firm/')) {
  $("#register_ps_viewer").on('click', function(e){
    $('#register_ps_viewer_popUp').removeClass('hide');
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // For a smooth scrolling effect
    });
  });
  $("#login_ps_viewer").on('click', function(e){
    $('#login_ps_viewer_popUp').removeClass('hide');
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // For a smooth scrolling effect
    });
  });
  $('#closeBtn').on('click', function(e){
    $('#register_ps_viewer_popUp').addClass('hide');
  });
  $('#closeBtn2').on('click', function(e){
    $('#login_ps_viewer_popUp').addClass('hide');
  });
  $(document).keyup(function(e) {
   if (e.key === "Escape") {
    $('#register_ps_viewer_popUp').addClass('hide');
    $('#login_ps_viewer_popUp').addClass('hide');
   }
  });
}
$("#pse_login").on('click', function(e){
  $('#custom-pse-login').removeClass('hide');
});
$('#close-customlogin').on('click', function(e){
  $('#custom-pse-login').addClass('hide');
});
$(document).keyup(function(e) {
 if (e.key === "Escape") {
  $('#custom-pse-login').addClass('hide');
 }
});